// extracted by mini-css-extract-plugin
export default {"price":"K8-z","priceRow":"L8-z","onSale":"M8-z","msrpLabelPrice":"N8-z","msrpLabel":"O8-z","originalPrice":"P8-z","percentOff":"Q8-z"};